export { default } from './InputIcon';
